export default {

	/**
	 * gibt Sprache und Land aus navigator.languages als strukturiertes Array von Objekten zurück.
	 *
	 * @returns {*[]}
	 */
	getBrowserLocales: function()
	{
		let browserLanguages = navigator.languages;
		let browserLocales = [];

		if(browserLanguages instanceof Array) {
			for(let lang in browserLanguages) {
				// filter(), um leere Elemente aus dem Array zu entfernen (siehe https://stackoverflow.com/a/2843625)
				let match = browserLanguages[lang].match(/^([a-z]{2})(-([A-Z]{2}))?/).filter(n => n);
				if(match) {
					if(match.length === 2) {
						browserLocales.push({
							l: match[1],
							c: null
						});
					} else if(match.length === 4) {
						browserLocales.push({
							l: match[1],
							c: match[3]
						});
					}
				}
			}
		}

		return browserLocales;
	},

	/**
	 * gibt aus einer Liste das bevorzugte Land zu einer Sprache zurück.
	 *
	 * @return {String|null}
	 */
	getCountryFromLocale: function(language)
	{
		// Hier sollten alle Web-Locales zu den entsprechenden Ländern gemappt werden.
		// TODO: dieses Mapping serverseitig durchführen und die Default-Country an den Client übergeben
		let countries = {
			de: 'DE',
			en: 'GB',
			en_US: 'US',
			en_GB: 'GB',
			fr: 'FR',
			nl: 'NL',
			pl: 'PL',
			ru: 'RU',
		};

		// Property-Test siehe https://stackoverflow.com/a/39283005/4576064
		if(Object.prototype.hasOwnProperty.call(countries, language)) {
			return countries[language];
		}

		return null;
	},

	/**
	 * ermittelt das bevorzugte Land des Browsers.
	 *
	 * @return {String|null}
	 */
	getBrowserCountry: function()
	{
		let browserLocales = this.getBrowserLocales();

		// Die erste Sprache ist am relevantesten. Daher suchen wir nach einem Land, welches die gleiche Sprache hat.
		// Im Idealfall ist im ersten Eintrag bereits ein Land enthalten. Wenn nicht, suchen wir in den weiteren
		// Einträgen nach einem Land.

		if(browserLocales.length) {
			if(browserLocales[0].c) {
				return browserLocales[0].c;
			}

			for(let i = 1; i < browserLocales.length; i++) {
				if((browserLocales[i].l === browserLocales[0].l) && browserLocales[i].c) {
					return browserLocales[i].c;
				}
			}
		}

		return null;
	}
};
